import { 
    get_support_customer_service_data, 
    support_customer_service 
} from "../libraries/coreApp/support_customer_service";


window.support_disabled = false;
async function set_support_service(){
    const today = new Date();
    let support_customer_service_class = null;
    let support_customer_service_data = await get_support_customer_service_data();
    if (support_customer_service_data !== null && typeof support_customer_service_data !== "undefined") {
        support_customer_service_class = new support_customer_service(support_customer_service_data);
    }else{
        throw("support_customer_service_data are undefined or null");
    }


    const isButtonDisabled = support_customer_service_class.isSupportButtonDisabled(today);

    window.support_disabled = isButtonDisabled;
}

set_support_service();

/**
 * To BUILD
 * npm run build
 * set: input: "src/controllers/support_service_controller.js",
 * output: "default/public/assets/js"
 * 
 * in ROLLUP
 * 
 */